import { css, unsafeCSS } from 'lit';
import { sbkCoreBreakpointLg } from "@/tokens/variables";

const breakpointLg = unsafeCSS(`${sbkCoreBreakpointLg}`);

export const style = css`
    :host {
        display: inline-block;
    }

    * {
        box-sizing: border-box;
    }

    .indicator {
        font: var(--sbkFileUploadTypographyTitle);
        gap: var(--sbkIndicatorSpacingGapLabel);
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .indicator-circle {
        width: var(--sbkIndicatorSizingEllipse);
        height: var(--sbkIndicatorSizingEllipse);
        border-radius: 50%;
        display: block;
        flex-shrink: 0;
    }

    .indicator-label {
        font: var(--sbkIndicatorTypographySmallScreenLabel);

        @media (min-width: ${breakpointLg}) {
            font: var(--sbkIndicatorTypographyLargeScreenLabel);
        }
    }

    .indicator-info {
        .indicator-circle {
            background: var(--sbkIndicatorFgColorOnLightDefault);
        }
    }

    .indicator-note {
        .indicator-circle {
            background: var(--sbkIndicatorFgColorOnLightNote);
        }
    }

    .indicator-error {
        .indicator-circle {
            background: var(--sbkIndicatorFgColorOnLightError);
        }
    }

    .indicator-success {
        .indicator-circle {
            background: var(--sbkIndicatorFgColorOnLightSuccess);
        }
    }
`;